import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import MovieSection from "./components/MovieSection";

export default function Home() {
  useEffect(() => {
    document.title = "大师兄影视 - 最新上映热播推荐更新快抢先看新片速递 高清免费在线观看不卡顿全集播放电影大全综艺节目";
  }, []);

  return (
    <div className="min-h-screen bg-background-50" data-product-shop>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />

        <MovieSection
          title="最新上映"
          subtitle="院线大片抢先看，高清画质不卡顿"
          icon="ri-sparkling-line"
          linkTo="/category?type=movie"
          linkLabel="更多电影"
          filter={(m) => m.isNew}
          limit={6}
        />

        <div className="bg-background-100">
          <MovieSection
            title="热播推荐"
            subtitle="全网最热影视，都在大师兄影视"
            icon="ri-fire-line"
            linkTo="/category"
            linkLabel="查看全部"
            filter={(m) => m.isHot}
            limit={6}
          />
        </div>

        <MovieSection
          title="新片速递"
          subtitle="每日更新，不放过任何一部好片"
          icon="ri-rocket-line"
          linkTo="/category"
          linkLabel="查看全部"
          filter={(m) => m.isNew}
          limit={12}
        />

        <div className="bg-background-100">
          <MovieSection
            title="电影大全"
            subtitle="从国产佳作到好莱坞大片，一网打尽"
            icon="ri-film-line"
            linkTo="/category?type=movie"
            linkLabel="全部电影"
            filter={(m) => m.category === "movie"}
            limit={6}
          />
        </div>

        <MovieSection
          title="综艺推荐"
          subtitle="热门综艺、真人秀，精彩不间断"
          icon="ri-live-line"
          linkTo="/category?type=variety"
          linkLabel="全部综艺"
          filter={(m) => m.category === "variety"}
          limit={6}
        />

        <div className="bg-background-100">
          <MovieSection
            title="动漫精选"
            subtitle="国产动画崛起，精彩不容错过"
            icon="ri-ghost-line"
            linkTo="/category?type=anime"
            linkLabel="全部动漫"
            filter={(m) => m.category === "anime"}
            limit={6}
          />
        </div>

        <section className="py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-600 via-primary-700 to-background-100 p-8 md:p-12 text-center">
              <div className="relative z-10">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
                  追剧不等待，更新快人一步
                </h2>
                <p className="text-sm text-white/70 mb-6 max-w-lg mx-auto">
                  大师兄影视每日同步更新最新剧集，高清流畅不卡顿。加入我们，和千万用户一起享受极致观影体验。
                </p>
                <a
                  href="/category"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-white text-primary-700 font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer no-underline whitespace-nowrap"
                >
                  <i className="ri-flashlight-line text-lg"></i>
                  开始追剧
                </a>
              </div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-primary-400/20 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-400/15 rounded-full blur-3xl"></div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-100">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-2">
                为什么选择大师兄影视？
              </h2>
              <p className="text-xs text-foreground-500">千万用户信赖的影视平台</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { icon: "ri-speed-up-line", title: "更新最快", desc: "每日第一时间同步更新" },
                { icon: "ri-4k-line", title: "高清画质", desc: "1080P/4K超清体验" },
                { icon: "ri-shield-check-line", title: "流畅不卡", desc: "CDN全球加速播放" },
                { icon: "ri-heart-pulse-line", title: "完全免费", desc: "无需会员永久免费" },
              ].map((item) => (
                <div key={item.title} className="flex flex-col items-center text-center p-4 md:p-5 rounded-xl bg-background-50">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                    <i className={`${item.icon} text-lg md:text-xl text-primary-600`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "大师兄影视 - 首页",
            "url": "https://www.dashixiong.tv/",
            "isPartOf": {
              "@type": "WebSite",
              "name": "大师兄影视",
              "url": "https://www.dashixiong.tv/",
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "首页",
                  "item": "https://www.dashixiong.tv/",
                },
              ],
            },
          }),
        }}
      />
    </div>
  );
}